import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-forgotsubcriber',
  templateUrl: './forgotsubcriber.component.html',
  styleUrls: ['./forgotsubcriber.component.sass']
})
export class ForgotsubcriberComponent implements OnInit {

  public subscriberEmail:string='';
  public status:number=0;
  emailF= new FormControl('',[
    Validators.required,
    Validators.email
  ]);
  @Input() forgotPasawordStatus;
  @Input() email;
  @Input() subscriber;
  public ResponseList;
  @Output() updateView = new EventEmitter<number>();
  @Output() updateSubscriber = new EventEmitter<number>();
  @Output() updateEmail = new EventEmitter<number>();
  @Output() updateQuestions = new EventEmitter<number>();
  constructor(private services:Service,public global:GlobalService,private loadingScreenService:LoadingScreenService) {

   }
  ngOnInit() {
  }
  getIn(event){
    if(event.key){
      if(event.key=="Enter"){
        this.validarUser2();
      }
      else{
        this.global.validateInputKey(event);  
      }
    }
    else{
      this.global.validateInputKey(event);
    }
  }
  validarUser2() {
    if (this.emailF.invalid && this.emailF.value=="") {
      this.global.notif('Debe colocar un correo electrónico o Número de Teléfono.');
    }
    else if(this.emailF.invalid && this.emailF.value!=""){
      this.global.notif('Debe ingresar un correo electrónico o Número de Teléfono válido.');
    }
    else{
      this.loadingScreenService.startLoading();
      this.services.getChallengeQuestions3(this.emailF.value).subscribe(data =>{
        this.loadingScreenService.stopLoading();
        if(data.hasError ==false){
          this.email=data.email;
          this.ResponseList=data.ResponseList;
          if(this.ResponseList!==[]&&this.ResponseList!==null){
            this.forgotPasawordStatus=2;
          }
          else{
            this.forgotPasawordStatus=31;
          }
          
          this.subscriber=data.subscriber;
          this.updateView.emit(this.forgotPasawordStatus);
          this.updateEmail.emit(this.email);
          this.updateSubscriber.emit(this.subscriber);
          this.updateQuestions.emit(this.ResponseList);
        }
        else{
          this.global.notif(data.errorDesc);
        }
      });

    }
  }
 
  validateUsernameInput(){
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let expr = /^([0-9])*$/; 
    return (emailRegex.test(this.subscriberEmail) || expr.test(this.subscriberEmail));
  }
}
